import { render, staticRenderFns } from "./IconAlerta.vue?vue&type=template&id=2f48fd5f"
import script from "./IconAlerta.vue?vue&type=script&lang=ts"
export * from "./IconAlerta.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports